import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettingsService } from '@services/app-settings/app-settings.service';
import { BrandsEnum } from '@models/enums/brands.enum';
import { tap } from 'rxjs';
import { ApplicationInsightsService } from '@services/application-insights/application-insights.service';
import { isPlatformServer } from '@angular/common';

export const apiRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const appInsightsService = inject(ApplicationInsightsService);
  const platformId = inject(PLATFORM_ID);
  const start = Date.now();

  if (
    req.url.startsWith(environment.apiBaseUrl) ||
    req.url.startsWith(environment.cmsBaseUrl)
  ) {
    const router = inject(Router);
    const appSettingsService = inject(AppSettingsService);

    req = req.clone({
      withCredentials: true,
      headers: req.headers
        .set('Page-Url', router.url)
        .set(
          'Brand',
          appSettingsService.brandSig() ??
            appSettingsService.getBrandFromHostname() ??
            BrandsEnum.FEAZEL,
        )
        .set('X-App-Name', 'robyn-ui'),
    });
    if (isPlatformServer(platformId)) {
      if (req.url.includes('cms')) {
        console.log('[API Interceptor] CMS Request URL:', req.url);
        console.log(
          '[API Interceptor] CMS Request Brand:',
          req.headers.get('Brand'),
        );
      }
    }
  }

  return next(req).pipe(
    tap({
      next: () => {
        const duration = Date.now() - start;
        appInsightsService.logDependencyData(
          req.url,
          req.url,
          duration,
          true,
          200,
          req.method,
        );
      },
      error: (error: HttpErrorResponse) => {
        const duration = Date.now() - start;
        appInsightsService.logDependencyData(
          req.url,
          req.url,
          duration,
          false,
          error.status,
          req.method,
        );
      },
    }),
  );
};
